var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChMisalignmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9865 9.5L14.4859 11.5844L13.6563 11.0661C13.0655 10.6173 12.3311 10.3512 11.5351 10.3512C9.58259 10.3512 7.99976 11.9515 7.99976 13.9256C7.99976 15.8997 9.58259 17.5 11.5351 17.5C13.2455 17.5 14.6722 16.272 14.9998 14.6405",
    stroke: "#EE7D4D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49976 5.50049C5.27912 5.50415 4.60358 5.53335 4.04849 5.76634C3.27096 6.09269 2.63777 6.69552 2.26786 7.46158C1.96594 8.08687 1.91653 8.88799 1.81771 10.4902L1.66287 13.0009C1.41714 16.9853 1.29428 18.9775 2.46344 20.2388C3.63261 21.5 5.60228 21.5 9.54163 21.5H13.4579C17.3972 21.5 19.3669 21.5 20.5361 20.2388C21.7052 18.9775 21.5824 16.9853 21.3366 13.0009L21.1818 10.4902C21.083 8.88799 21.0336 8.08687 20.7317 7.46158C20.3617 6.69552 19.7286 6.09269 18.951 5.76634C18.3959 5.53335 17.7204 5.50415 16.4998 5.50049",
    stroke: "#EE7D4D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 6.5L15.6139 4.28543C15.2317 3.32996 14.8992 2.2461 13.9164 1.75955C13.3922 1.5 12.7614 1.5 11.4998 1.5C10.2382 1.5 9.60736 1.5 9.08311 1.75955C8.10036 2.2461 7.76777 3.32996 7.38558 4.28543L6.49976 6.5",
    stroke: "#EE7D4D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4996 5.5H11.5085",
    stroke: "#EE7D4D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChMisalignmentIcon);
export default __webpack_public_path__ + "static/media/ch-misalignment-icon.ed8e6ef4e6a5b47fb0d200a074695bdb.svg";
export { ForwardRef as ReactComponent };